document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".about-ladder[data-section-id]").forEach(function (root) {
    var sectionId = root.getAttribute("data-section-id");
    var wrapper = document.getElementById("shopify-section-" + sectionId);
    var track = root.querySelector(".about-ladder__track");
    var slots = root.querySelectorAll(".about-ladder__slot");
    if (!wrapper || !track || slots.length < 3) return;

    var slot0 = slots[0];
    var slot1 = slots[1];
    var slot2 = slots[2];
    var mqMobile = window.matchMedia("(max-width: 768px)");
    var mqReduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    var main = document.getElementById("MainContent");

    var move1 = 0;
    /** Third column translate when p1=1, p2=0 (half of 3rd image peeks at viewport bottom). */
    var move2Peek = 0;
    /** Third column translate when p1=0, p2=0 (3rd image off-screen; only 2nd peeks). */
    var move2Initial = 0;
    var ticking = false;

    function isAnimEnabled() {
      return !mqMobile.matches && !mqReduced.matches;
    }

    /** CSS `top` on sticky pin (e.g. header offset); used so peek math does not assume pin is at y=0. */
    function stickyTopInsetPx(pinEl) {
      if (!pinEl) return 0;
      var t = parseFloat(window.getComputedStyle(pinEl).top);
      return isFinite(t) ? t : 0;
    }

    function measureMoves() {
      slot1.style.transform = "";
      slot2.style.transform = "";
      root.classList.remove("is-slot-2-arrived", "is-complete");

      var grid = root.querySelector(".about-ladder__grid");
      var pin = root.querySelector(".about-ladder__pin");
      var media1 = slot1.querySelector(".about-ladder__media");
      var media3 = slot2.querySelector(".about-ladder__media");
      void root.offsetHeight;

      var step = grid ? grid.offsetHeight : slot0.offsetHeight;
      step = Math.max(step, 1);

      if (!grid || !media1) {
        move1 = step;
        move2Peek = step * 2;
        move2Initial = move2Peek + step;
        syncTrackHeight();
        return;
      }

      var ih = window.innerHeight;
      var inset = pin ? stickyTopInsetPx(pin) : 0;
      var rect1 = media1.getBoundingClientRect();
      if (pin) {
        var dist1 = rect1.top - pin.getBoundingClientRect().top;
        move1 = Math.max(0, ih - rect1.height / 2 - inset - dist1);
      } else {
        move1 = Math.max(0, ih - rect1.height / 2 - rect1.top);
      }

      // Modest vertical gap for the stacked “ladder” start; large values added dead scroll
      // after the third card had already reached the row.
      var extraDown = Math.max(Math.round(step * 0.22), Math.round(ih * 0.06));
      if (!media3) {
        move2Peek = move1 + step;
        move2Initial = move2Peek + extraDown;
        syncTrackHeight();
        return;
      }

      var rect3 = media3.getBoundingClientRect();
      if (pin) {
        var dist3 = rect3.top - pin.getBoundingClientRect().top;
        move2Peek = Math.max(0, ih - rect3.height / 2 - inset - dist3);
      } else {
        move2Peek = Math.max(0, ih - rect3.height / 2 - rect3.top);
      }
      move2Initial = move2Peek + extraDown;

      syncTrackHeight();
    }

    function syncTrackHeight() {
      if (!isAnimEnabled()) {
        track.style.height = "";
        return;
      }
      var pin = root.querySelector(".about-ladder__pin");
      var ih = window.innerHeight;
      var pinH = pin ? pin.offsetHeight : 0;
      var raw = parseFloat(track.getAttribute("data-scroll-stage-vh"), 10);
      var scrollVh = isFinite(raw) && raw > 0 ? raw : 150;
      scrollVh = Math.max(scrollVh, 100);
      // Scroll distance matches actual column travel (ends when row 3 aligns), not a loose vh budget.
      var leg1 = Math.max(move1, 1);
      var leg2 = Math.max(move2Initial - move2Peek, 1);
      var baseAnimPx = leg1 + leg2;
      // Theme: 100 = tight (no extra padding), higher = proportionally longer scrub.
      var desiredAnimTrack = Math.max(
        Math.round(baseAnimPx * (scrollVh / 100)),
        Math.round(ih * 0.02),
        1
      );
      var extraScroll = Math.max(0, desiredAnimTrack + ih - pinH);
      track.style.height = pinH + extraScroll + "px";
    }

    function resetTransforms() {
      slot1.style.transform = "";
      slot2.style.transform = "";
      root.classList.remove("is-slot-2-arrived", "is-complete");
    }

    function mainIsScrollContainer(mainEl) {
      if (!mainEl) return false;
      var cs = getComputedStyle(mainEl);
      var oy = cs.overflowY;
      var scrollableY = oy === "auto" || oy === "scroll" || oy === "overlay";
      return scrollableY && mainEl.scrollHeight > mainEl.clientHeight + 2;
    }

    function windowScrollY() {
      var se = document.scrollingElement || document.documentElement;
      return se.scrollTop || window.pageYOffset || 0;
    }

    function offsetFromMainTop(el, mainEl) {
      if (!mainEl || !el || !mainEl.contains(el)) return 0;
      var y = 0;
      var n = el;
      while (n && n !== mainEl) {
        var p = n.parentElement;
        if (!p) return y;
        for (var sib = p.firstElementChild; sib && sib !== n; sib = sib.nextElementSibling) {
          y += sib.offsetHeight;
        }
        n = p;
      }
      return y;
    }

    function scrollIntoWrapperPx() {
      var relTop = main ? offsetFromMainTop(wrapper, main) : 0;
      if (mainIsScrollContainer(main) && main) {
        return main.scrollTop - relTop;
      }
      if (main) {
        var wy = windowScrollY();
        var mainTopDoc = wy + main.getBoundingClientRect().top;
        var startDoc = mainTopDoc + relTop;
        return wy - startDoc;
      }
      return -wrapper.getBoundingClientRect().top;
    }

    function easeOutCubic(x) {
      return 1 - Math.pow(1 - x, 3);
    }

    function applyTransforms(p1, p2) {
      var offset2 = move1 * (1 - p1);
      var offset3 =
        move2Peek * (1 - p2) + (move2Initial - move2Peek) * (1 - p1) * (1 - p2);

      slot1.style.transform = offset2 > 0.5 ? "translate3d(0, " + offset2 + "px, 0)" : "";
      slot2.style.transform = offset3 > 0.5 ? "translate3d(0, " + offset3 + "px, 0)" : "";

      root.classList.toggle("is-slot-2-arrived", p1 >= 0.999);
      root.classList.toggle("is-complete", p1 >= 0.999 && p2 >= 0.999);
    }

    function updateLadderScroll() {
      ticking = false;

      if (!isAnimEnabled()) {
        resetTransforms();
        return;
      }

      var ih = window.innerHeight;
      var trackH = Math.max(track.offsetHeight, 1);
      var animTrack = Math.max(trackH - ih, 1);
      var scrolled = scrollIntoWrapperPx();
      var progress = Math.min(Math.max(scrolled / animTrack, 0), 1);

      var p1 = easeOutCubic(Math.min(Math.max(progress / 0.5, 0), 1));
      var p2 = 0;
      if (progress > 0.5) {
        p2 = easeOutCubic(Math.min((progress - 0.5) / 0.5, 1));
      }

      applyTransforms(p1, p2);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateLadderScroll);
      }
    }

    function onResizeOrBreakpoint() {
      if (isAnimEnabled()) {
        measureMoves();
      } else {
        resetTransforms();
      }
      onScroll();
    }

    measureMoves();
    applyTransforms(0, 0);
    updateLadderScroll();

    root.querySelectorAll(".about-ladder__media img").forEach(function (img) {
      if (!img.complete) {
        img.addEventListener("load", onResizeOrBreakpoint, { once: true });
      }
    });

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResizeOrBreakpoint, { passive: true });
    if (main) main.addEventListener("scroll", onScroll, { passive: true });
    mqMobile.addEventListener("change", onResizeOrBreakpoint);
    mqReduced.addEventListener("change", onResizeOrBreakpoint);
  });
});
